import React, { useEffect } from 'react';
import { useParams, useHistory, useLocation, RouteComponentProps } from 'react-router-dom';
import { MBSAccessHelper, authenticationService, useAuthStore, useConfigStore } from '@fides/fides-react-components';
import { AxiosError } from 'axios';
import NotAuthenticated from '../../components/layout/NotAuthenticated/NotAuthenticated';
import { useTranslation } from 'react-i18next';
import { LoadingOverlay } from '../../components/layout/Loading/Loading';
import { getPortalUser } from '../../api/helper';
import { getApplications } from '../../api/services';

const PORTAL_URL_LOGIN_ROUTE = '#!/public/login/';
export interface RedirectState {
    from?: RouteComponentProps['location'];
}

const buildLoginUrl = (portalUrl: string, fromRoute: any) => {
    const redirect_to = `${window.location.origin}${fromRoute?.pathname}`;
    return `${portalUrl}${PORTAL_URL_LOGIN_ROUTE}?redirect_to=${redirect_to}`;
};

const DownloadCenterLanding = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const params: any = useParams();

    const [authError, setAuthError] = React.useState<Error>();

    const portalUrl = useConfigStore.getState().portalUrl;

    const userIsLoggedIn = useAuthStore((state) => state.userIsLoggedIn);
    const setUser = useAuthStore(state => state.setUser);
    const unsetUser = useAuthStore(state => state.unsetUser);

    const fromRoute = React.useMemo(() => {
        const redirectState = location.state as RedirectState;
        return redirectState?.from ?? { pathname: '/' };
    }, [location.state]);

    useEffect(() => {
        if (params?.token) {
            history.push("/overviewReports");
        }
    }, [history, params]);


    useEffect(() => {
        if (userIsLoggedIn || !portalUrl) return;

        const getUserData = async () => {
            try {
                const basicUser = await authenticationService.login(portalUrl);
                const portalUser = getPortalUser(basicUser);
                const applications = await getApplications(portalUrl);
                portalUser.applications = applications;
                const accessHelper = new MBSAccessHelper(portalUser);
                const isCSEndUser = accessHelper.isCSEndUser();
                basicUser.isCSEndUser = isCSEndUser;

                setUser(basicUser);
                i18n.changeLanguage(basicUser.domainUser.settings?.language || 'en');
                history.replace(fromRoute);
            } catch (error) {
                setAuthError(error as AxiosError)
            }
        }

        getUserData();

    }, [setUser, userIsLoggedIn, history, portalUrl, fromRoute, i18n]);



    if (authError) {
        unsetUser();
        return <NotAuthenticated loginUrl={buildLoginUrl(portalUrl, fromRoute)} />;
    }

    if (!userIsLoggedIn) {
        return <LoadingOverlay loadingText={t('generic.loading')} />;
    }

    return null;
}

export default DownloadCenterLanding;